import "@hotwired/turbo-rails";
import { Application } from "@hotwired/stimulus";
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers";

export default function HotwireStart() {
  window.Stimulus = Application.start();
  const context = require.context("../controllers", true, /\.js$/);
  Stimulus.load(definitionsFromContext(context));
}
